import React from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import queryClient from 'react-query-settings/queryClient';

import AppWrapper from 'components/apps/AppWrapper';
import NearestMedicalLocationFormSection from 'components/medicalLocations/NearestMedicalLocationFormSection';

import { resourceShape } from 'components/helpers/serialisableResources';

export default function NearestMedicalLocationFormSectionWrapper({
  contextProps,
  wrappedProps,
}) {
  return (
    <AppWrapper {...contextProps}>
      <QueryClientProvider client={queryClient}>
        <NearestMedicalLocationFormSection {...wrappedProps} />
      </QueryClientProvider>
    </AppWrapper>
  );
}

NearestMedicalLocationFormSectionWrapper.propTypes = {
  wrappedProps: PropTypes.shape({
    domainMedicalLocation: resourceShape('medicalLocation'),
    domainMedicalLocationMapConfiguration: resourceShape(
      'medicalLocationMapConfiguration',
    ),
    domainMedicalLocationMapConfigurationImageUrl: PropTypes.string,
  }),
};
